// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { SwipeList, SwipeOut } from './components'
import Vue from 'vue'

Vue.component('SwipeList', SwipeList)
Vue.component('SwipeOut', SwipeOut)
